export const GET_CURRENT_BRAND_SUCCESS = 'GET_CURRENT_BRAND_SUCCESS'
export const GET_CURRENT_BRAND_ERROR = 'GET_CURRENT_BRAND_ERROR'
export const GET_CURRENT_BRAND_STARTED = 'GET_CURRENT_BRAND_STARTED'
export const UPDATE_CURRENT_BRAND = 'UPDATE_CURRENT_BRAND'
export const UPDATE_CURRENT_BRAND_SUCCESS = 'UPDATE_CURRENT_BRAND_SUCCESS'
